window.addEventListener("load", () => {
    setTimeout(() => {

        const host = document.querySelector("#reconvert-slot-9");

        if (!host || !host.shadowRoot) return;

        const style = document.createElement("style");

        style.textContent = `
           .custom-space .heading_font p{
               
                color: #000000;
                font-size: 24px;
                align-item: left !important;

               
            }
            // .py-2 {
            //     padding-top: 0.5rem;
            //     padding-bottom: 0.5rem;
            //     background: #ffffff;
            //     padding: 20px;
            //     border-radius: 16px;
            //     border: 1px solid #000000;
            // }
            .section_content .quantity_selector_style {
                min-height: 47.33px;
                width: 55%;
            }
            .custom-space .heading_font span {
                color: #000000;
                font-size: 24px !important;
                align-item: left !important;

            }
            .border.border-solid.border-gray-300.rounded-\[10px\]{
                border:1px solid #e5e5e5 !important;
                border-radius:12px !important;
                overflow:hidden;
                transition:.3s;
                background:#fff;
            }

            .border.border-solid.border-gray-300.rounded-\[10px\]:hover{
                box-shadow:0 12px 30px rgba(0,0,0,.08);
            }

            .product-image{
                padding:12px !important;
                object-fit:cover !important;
                transition:.3s;
            }
            .heading_font.break-words{
                font-size:20px !important;
                font-weight:600 !important;
                line-height:1.4 !important;
                color:#111 !important;
                margin-top: 20px;
                margin-bottom: 10px;
            }
            .w-full.leading-none button{
                background:none !important;
                border:none !important;
                padding:0 !important;
                color:#666 !important;
                font-size:15px !important;
            }

            .w-full.leading-none button:hover{
                color:#000 !important;
            }
            .normal_price{
                font-size: 20px !important;
                font-weight: 700 !important;
                color: #000 !important;
                margin-bottom: 20px;
            }
            .quantity_selector_style{
                border:1px solid #ddd !important;
                border-radius:8px !important;
                min-height:52px !important;
                background:#fff;
            }

            .quantity_lable{
                font-size:12px !important;
                color:#777;
            }

            .quantity_input{
                font-size:18px !important;
                font-weight:600;
            }

            .quantity_svg_style{
                fill:#111 !important;
            }

            .quantity_selector_style svg{
                cursor:pointer;
            }

            .quantity_selector_style svg:hover{
                transform:scale(1.15);
            }
                .body_font.pb-2{
                margin-top:25px !important;
                margin-bottom:25px !important;
            }

            .body_font.pb-2 p{
                font-size:18px !important;
                font-weight:600;
            }
                #checkout_btn{
                height:56px !important;
                border:none !important;
                border-radius:8px !important;
                background:#000 !important;
                color:#fff !important;
                font-size:18px !important;
                font-weight:600 !important;
            }

            #checkout_btn:hover{
                background:#222 !important;
            }
                @media(max-width:767px){
                
                    .heading_font.break-words {
                        font-size: 15px !important;
                        font-weight: 600 !important;
                        color: #111 !important;
                        margin-top: 20px;
                        margin-bottom: 10px;
                    }
                    .normal_price {
                        font-size: 15px !important;
                        font-weight: 700 !important;
                        color: #000 !important;
                        margin-bottom: 20px;
                    }
                    .section_content .quantity_selector_style {
                        min-height: 47.33px;
                        width: 100%;
                    }
                }

                    `;

        host.shadowRoot.appendChild(style);

    }, 2000);
});